var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoryLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1673 8.33325C19.1673 7.89122 18.9917 7.4673 18.6792 7.15474C18.3666 6.84218 17.9427 6.66658 17.5007 6.66658H12.234L13.034 2.85825C13.0507 2.77492 13.059 2.68325 13.059 2.59159C13.059 2.24992 12.9173 1.93325 12.6923 1.70825L11.809 0.833252L6.32565 6.31659C6.01732 6.62492 5.83398 7.04158 5.83398 7.49992V15.8333C5.83398 16.2753 6.00958 16.6992 6.32214 17.0118C6.6347 17.3243 7.05862 17.4999 7.50065 17.4999H15.0007C15.6923 17.4999 16.284 17.0833 16.534 16.4833L19.0507 10.6083C19.1257 10.4166 19.1673 10.2166 19.1673 9.99992V8.33325ZM0.833984 17.4999H4.16732V7.49992H0.833984V17.4999Z",
    fill: "#333333",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryLike);
export default __webpack_public_path__ + "static/media/storyLike.871b8c77f7167fe05b1fffe97ef9fdad.svg";
export { ForwardRef as ReactComponent };